import React, { useState, useContext, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ModalComp, Time } from "../";
import { Alert } from "../";
import Cookies from "js-cookie";
import {
  addNewScenario,
  scenarioAddWidget,
  scenarioEdit,
  limitList,
  scenariosList,
  scenarioWidgetEdit,
} from "../../api";
import { ScenariosZones } from "./ScenariosZone";
import { useTranslation } from "react-i18next";
import { FiPlus, FiCheck, FiX, FiZap, FiTrash2 } from "react-icons/fi";

const AddScenario = ({
  titleEdit,
  iconEdit,
  uid,
  submit,
  closeAddScenario,
  closeModal,
  props,
  scenarioCommandEdit,
  setScenarioCommandEdit,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((prevState) => !prevState);
  const [icon, setIcon] = useState(iconEdit || "icon-slepp");
  const [openTimeModal, setOpenTimeModal] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const toggleTime = () => setOpenTimeModal(!openTimeModal);
  const toggleScenarioZone = () =>
    setOpenScenarioZoneModal(!openScenarioZoneModal);
  const token = Cookies.get("token");
  const [title, setTitle] = useState(titleEdit || "");
  const [scenarioCommand, setScenarioCommand] = useState([]);
  const [widgetIndex, setWidgetIndex] = useState("");
  const [openScenarioZoneModal, setOpenScenarioZoneModal] = useState(false);
  const [scenarioCommandEdit1, setScenarioCommandEdit1] =
    useState(scenarioCommandEdit);
  let [scenarioCommandCopy, setScenarioCommandCopy] = useState(scenarioCommand);
  const icons = [
    "icon-slepp",
    "icon-muic",
    "icon-in",
    "icon-out",
    "icon-sun",
    "icon-tvv",
  ];
  
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  
  const handleDeleteWidget = (item, i) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var formdata = new FormData();
    formdata.append("scenariowg_id", item.uid);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    fetch("https://assessn.mmaviot.com/api/scenariowg_remove", requestOptions)
      .then((response) => response.text())
      .then((result) => result)
      .catch((err) => {
        setShowAlert({
          show: true,
          message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
          type: "Error",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 2000);
      });
    const cllose = scenarioCommandEdit.filter((item, index) => index !== i);
    setScenarioCommandEdit(cllose);
    setShowAlert({
      show: true,
      question: false,
      message: t("رویداد مورد نظر شما با موفقیت حذف گردید"),
      type: "Success",
    });
    setTimeout(() => {
      setShowAlert((prev) => ({ ...prev, show: false }));
    }, 2000);
  };

  function handleScenarioTitle(e) {
    setTitle(e.target.value);
  }
  const [scenarioId, setScenarioId] = useState("");
  const [selectWidget, setSelectWidget] = useState(true);

  function handleShowHideFunction() {
    if (title && title.trim()) {
      setOpenScenarioZoneModal(true);
    } else {
      setShowAlert({
        show: true,
        message: t("لطفا یک نام برای سناریوی خود انتخاب نمایید"),
        type: "Warning",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 5000);
    }
    setSelectWidget(!selectWidget);
  }

  const handleScenarioEdit = () => {
    // بررسی وجود نام سناریو
    if (!title || !title.trim()) {
      setShowAlert({
        show: true,
        message: t("لطفا یک نام برای سناریوی خود انتخاب نمایید"),
        type: "Warning",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 5000);
      return;
    }

    var data = new FormData();
    data.append("title", title);
    data.append("icon", icon);
    data.append("scenario_id", uid);

    scenarioEdit(data, token)
      .then(() => {
        // بررسی وجود رویداد
        const hasEvents = scenarioCommand.length > 0 || 
          (scenarioCommandEdit && scenarioCommandEdit.some(item => item.deleted_at?.Valid !== true));
        
        if (!hasEvents) {
          setShowAlert({
            show: true,
            message: t("ابتدا میبایست رویداد های سناریو را وارد نمایید"),
            type: "Error",
            question: false,
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 5000);
          return;
        }

        const seenSerials = {};
        let error_serial = false;
        
        // بررسی رویدادهای جدید
        for (let i = 0; i < scenarioCommand.length; i++) {
          const serialCommand = scenarioCommand[i]?.serial?.serial;
          if (serialCommand) {
            if (seenSerials[serialCommand]) {
              error_serial = true;
              break;
            }
            seenSerials[serialCommand] = true;
          }
        }
        
        // بررسی رویدادهای موجود (حذف نشده)
        if (!error_serial && scenarioCommandEdit) {
          for (let i = 0; i < scenarioCommandEdit.length; i++) {
            const item = scenarioCommandEdit[i];
            if (item?.deleted_at?.Valid === false || !item?.deleted_at) {
              const serialDevice = item?.serial_device;
              if (serialDevice) {
                if (seenSerials[serialDevice]) {
                  error_serial = true;
                  break;
                }
                seenSerials[serialDevice] = true;
              }
            }
          }
        }
        
        if (error_serial) {
          setShowAlert({
            show: true,
            message: t("عدم ثبت به علت ورود رویداد های تکراری"),
            type: "Error",
            question: false,
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 5000);
          return;
        }
        
        // ذخیره رویدادهای جدید
        const savePromises = scenarioCommand.map((item) => {
          var formData = new FormData();
          formData.append("serial", item?.serial?.serial);
          formData.append("widget", item?.id?.id);
          formData.append("command", item?.command?.command);
          formData.append("scenario_id", uid);
          return scenarioAddWidget(formData, token);
        });
        
        Promise.all(savePromises)
          .then(() => {
            setShowAlert({
              show: true,
              question: false,
              message: t("سناریو با موفقیت ویرایش گردید."),
              type: "Success",
            });
            setTimeout(() => {
              setShowAlert((prev) => ({ ...prev, show: false }));
              if (closeModal) closeModal();
              if (closeAddScenario) closeAddScenario();
            }, 2000);
          })
          .catch((err) => {
            setShowAlert({
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            });
            setTimeout(() => {
              setShowAlert((prev) => ({ ...prev, show: false }));
            }, 2000);
          });
      })
      .catch((err) => {
        if (err?.response?.status === 403) {
          Cookies.remove("token");
          if (props?.history) props.history.push("/login");
        }
        setShowAlert({
          show: true,
          message: t("خطا در ویرایش اطلاعات."),
          type: "Error",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 2000);
      });
  };

  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
  };
  
  const handleClose = (i) => {
    const cllose = scenarioCommand.filter(
      (index) => index?.caption?.caption !== i
    );
    setScenarioCommand(cllose);
  };
  
  const handleEditClose = (i) => {
    const close = scenarioCommandEdit1.filter((index, idx) => idx !== i);
    setScenarioCommandEdit1(close);
  };
  
  const handleAddScenarioWidget = () => {
    if (!title || !title.trim()) {
      setShowAlert({
        show: true,
        message: t("لطفا یک نام برای سناریوی خود انتخاب نمایید"),
        type: "Warning",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 5000);
      return;
    }
    
    if (scenarioCommandCopy.length === 0) {
      setShowAlert({
        show: true,
        message: t("ابتدا میبایست رویداد های سناریو را وارد نمایید"),
        type: "Error",
        question: false,
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ show: false }));
      }, 5000);
      return;
    }
    
    const seenSerials = {};
    let hasDuplicate = false;
    
    for (let i = 0; i < scenarioCommandCopy.length; i++) {
      const serial = scenarioCommandCopy[i]?.serial?.serial;
      if (serial) {
        if (seenSerials[serial]) {
          hasDuplicate = true;
          break;
        }
        seenSerials[serial] = true;
      }
    }
    
    if (hasDuplicate) {
      setShowAlert({
        show: true,
        message: t("عدم ثبت به علت ورود رویداد های تکراری"),
        type: "Error",
        question: false,
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ show: false }));
      }, 5000);
      return;
    }
    
    setShowAlert({
      show: true,
      message: t("آیا سناریوی ") + t(`${title}`) + t(" ثبت گردد؟"),
      type: "Warning",
      question: true,
      request: "addNewScenario",
    });
    setSelectWidget(!selectWidget);
    setScenarioCommandCopy([]);
  };
  
  useEffect(() => {
    if (scenarioId) {
      scenarioCommand.map((item) => {
        var data = new FormData();
        data.append("serial", item?.serial?.serial);
        data.append("widget", item?.id?.id);
        data.append("command", item?.command?.command);
        data.append("scenario_id", scenarioId);
        scenarioAddWidget(data, token)
          .then((result) => result)
          .catch((err) => {
            if (err?.response?.status === 403) {
              Cookies.remove("token");
              if (props?.history) props.history.push("/login");
            }
            setShowAlert({
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            });
            setTimeout(() => {
              setShowAlert((prev) => ({ ...prev, show: false }));
            }, 2000);
          });
      });
    }
  }, [scenarioId]);
  
  useEffect(() => {
    setScenarioCommandCopy(scenarioCommand);
  }, [scenarioCommand]);
  
  useEffect(() => {
    limitList(token)
      .then((result) => {
        if (result?.data?.data) {
          let x = result.data.data.scenario_limit_count - result.data.data.scenario_count;
          if (x !== undefined) {
            setShowAlert({
              show: true,
              message: x > 0
                ? t("شما برای انتخاب ") + x + t(" سناریو دیگر مجاز هستید")
                : t("شما مجاز به انتخاب سناریو جدید نیستید"),
              type: x > 0 ? "Warning" : "Error",
            });
            setTimeout(() => {
              setShowAlert((prev) => ({ ...prev, show: false }));
            }, 5000);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className="add-scenario-container">
      <ModalComp modal={openTimeModal} toggle={toggleTime} component={<Time />} />
      <ModalComp
        modal={openScenarioZoneModal}
        toggle={toggleScenarioZone}
        component={
          <ScenariosZones
            title={title}
            icon={icon}
            setScenarioCommand={setScenarioCommand}
            scenarioId={scenarioId}
          />
        }
      />

      <div className="add-scenario-header">
        <div className="add-scenario-icon">
          <FiZap size={22} />
        </div>
        <h3 className="add-scenario-title">{t("افزودن سناریو جدید")}</h3>
      </div>

      <p className="add-scenario-description">
        {t("نام سناریو و آیکون دلخواه خود را انتخاب نمایید.")}
      </p>

      <div className="add-scenario-name-section">
        <div className="add-scenario-input-wrapper">
          <input
            type="text"
            placeholder={t("نام سناریو")}
            className="add-scenario-input"
            value={title}
            onChange={handleScenarioTitle}
          />
        </div>
        
        <Dropdown isOpen={isOpen} toggle={toggle}>
          <DropdownToggle className="add-scenario-icon-btn">
            <i className={`${icon}`}></i>
          </DropdownToggle>
          <DropdownMenu>
            {icons.map((iconItem, idx) => (
              <DropdownItem key={idx} onClick={() => setIcon(iconItem)}>
                <i className={iconItem}></i>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="add-scenario-events">
        {(scenarioCommand.length > 0 || (submit && scenarioCommandEdit?.length > 0)) && (
          <div className="add-scenario-events-header">
            <FiZap size={14} />
            <span>{t("رویدادهای انتخاب شده")}</span>
          </div>
        )}
        
        <div className="add-scenario-events-list">
          {scenarioCommand?.map((item, index) => (
            <div key={index} className="add-scenario-event-item">
              <div className="add-scenario-event-info">
                <span className="add-scenario-event-name">
                  {item?.caption?.caption}
                </span>
                <span className="add-scenario-event-command">
                  {item?.command?.command === "10" ? t("روشن") : t("خاموش")}
                </span>
              </div>
              <button
                className="add-scenario-event-delete"
                onClick={() => handleClose(item?.caption?.caption)}
              >
                <FiX size={14} />
              </button>
            </div>
          ))}
          
          {submit && scenarioCommandEdit?.map((item, index) => (
            item?.deleted_at?.Valid !== true && (
              <div key={index} className="add-scenario-event-item">
                <div className="add-scenario-event-info">
                  <span className="add-scenario-event-name">
                    {item?.zone_widget_caption}
                  </span>
                  <span className="add-scenario-event-command">
                    {item?.command === "10" ? t("روشن") : t("خاموش")}
                  </span>
                </div>
                <button
                  className="add-scenario-event-delete"
                  onClick={() => handleDeleteWidget(item, index)}
                >
                  <FiTrash2 size={14} />
                </button>
              </div>
            )
          ))}
        </div>
      </div>

      <div className="add-scenario-buttons">
        <button
          type="button"
          className="add-scenario-btn-event"
          onClick={handleShowHideFunction}
        >
          <FiPlus size={16} />
          <span>{t("رویداد")}</span>
        </button>
        
        {submit ? (
          <button
            type="button"
            className="add-scenario-btn-submit"
            onClick={handleScenarioEdit}
          >
            <FiCheck size={16} />
            <span>{t("ثبت")}</span>
          </button>
        ) : (
          <button
            type="button"
            className="add-scenario-btn-submit"
            onClick={handleAddScenarioWidget}
          >
            <FiCheck size={16} />
            <span>{t("ثبت")}</span>
          </button>
        )}
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          setScenarioId={setScenarioId}
          question={showAlert.question}
          request={showAlert.request}
          close1={closeAddScenario}
          toggleAlert={toggleAlert}
        />
      )}
    </div>
  );
};

export { AddScenario };